import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import * as translations from "./translations";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            de: { translation: translations.de.translations },
            eng: { translation: translations.eng.translations },
            hr: { translation: translations.hr.translations },
            ro: { translation: translations.ro.translations },
        },
        fallbackLng: "eng",
        interpolation: {
            escapeValue: false,
        },
        detection: {
            // Language detection options
            order: ["localStorage", "navigator"], // Check localStorage first, then browser settings
            caches: ["localStorage"], // Persist language in localStorage
        },
    });

export default i18n;
